import { Entities } from '../Enums/Entities.enum';

export const COLUMNS_BY_GENERAL_SETTINGS_TYPE: Partial<
  Record<Entities, string[]>
> = {
  [Entities.ticketKind]: ['color', 'minutesPerTicket'],
};

export const COLUMN_DEFINITIONS = {
  [Entities.ticketKind]: {
    color: { cell: { type: 'Color' } },
  },
};
